export function capitalizeFirstLetter(string) {
  // return string.toLowerCase().charAt(0).toUpperCase() + string.slice(1);
  return (
    string.toLowerCase().charAt(0).toUpperCase() + string.toLowerCase().slice(1)
  );
}
